function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Badge, Tooltip } from '@mantine/core';
import { useIntl } from 'react-intl';
import styles from './AliasResponse.module.scss';
import classNames from 'classnames';
function AliasResponse(_param) {
    var response = _param.response, alias = _param.alias, className = _param.className, props = _object_without_properties(_param, [
        "response",
        "alias",
        "className"
    ]);
    var intl = useIntl();
    if (alias == null || alias.length === 0) {
        return /*#__PURE__*/ _jsx("p", _object_spread_props(_object_spread({
            className: classNames(styles.aliasResponse, className)
        }, props), {
            children: response
        }));
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.aliasResponse,
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                className: styles.tooltip,
                label: intl.formatMessage({
                    id: "0Oso9n",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Will trigger command "
                        },
                        {
                            type: 1,
                            value: "alias"
                        },
                        {
                            type: 0,
                            value: " instead."
                        }
                    ]
                }, {
                    alias: alias
                }),
                children: /*#__PURE__*/ _jsx(Badge, {
                    classNames: {
                        label: styles.label
                    },
                    variant: "inverse",
                    radius: "sm",
                    children: alias
                })
            }),
            /*#__PURE__*/ _jsx("p", _object_spread_props(_object_spread({
                className: className
            }, props), {
                children: response
            }))
        ]
    });
}
export default AliasResponse;
